(function () {
  function shouldSkip(node) {
    var parent = node.parentElement;
    return !parent || !!parent.closest('script, style, noscript, template');
  }

  function splitTextNode(node) {
    if (shouldSkip(node)) return false;
    var text = node.nodeValue;
    var idx = text.toLowerCase().indexOf('mask');
    if (idx === -1) return false;
    var parent = node.parentNode;
    if (!parent) return false;
    var before = text.slice(0, idx);
    var match = text.slice(idx, idx + 4);
    var after = text.slice(idx + 4);
    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));
    var span = document.createElement('span');
    span.setAttribute('style', 'color:#FF8A2B !important;');
    span.textContent = match;
    frag.appendChild(span);
    if (after) frag.appendChild(document.createTextNode(after));
    parent.replaceChild(frag, node);
    return true;
  }

  function run() {
    var header = document.getElementById('header-group');
    if (!header) return;
    var walker = document.createTreeWalker(header, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (!shouldSkip(n) && n.nodeValue && n.nodeValue.toLowerCase().indexOf('hauntmask') !== -1) nodes.push(n);
    }
    nodes.forEach(splitTextNode);
  }

  var attempts = 0;
  var interval = setInterval(function () { run(); attempts++; if (attempts > 20) clearInterval(interval); }, 250);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  var header = document.getElementById('header-group');
  if (header && 'MutationObserver' in window) {
    var obs = new MutationObserver(function () { run(); });
    obs.observe(header, { childList: true, subtree: true, characterData: true });
  }
})();

(function () {
  function disableProductStickyAddToCart() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;

    if (!document.getElementById('hm-disable-product-sticky-cart')) {
      var style = document.createElement('style');
      style.id = 'hm-disable-product-sticky-cart';
      style.textContent = 'sticky-add-to-cart{display:none!important;visibility:hidden!important;pointer-events:none!important;}';
      (document.head || document.documentElement).appendChild(style);
    }

    var bars = document.querySelectorAll('sticky-add-to-cart');
    for (var i = 0; i < bars.length; i++) {
      bars[i].remove();
    }
  }

  disableProductStickyAddToCart();
  document.addEventListener('DOMContentLoaded', disableProductStickyAddToCart);
  window.addEventListener('load', disableProductStickyAddToCart);

  var stickyAttempts = 0;
  var stickyInterval = setInterval(function () {
    disableProductStickyAddToCart();
    stickyAttempts++;
    if (stickyAttempts > 20) clearInterval(stickyInterval);
  }, 250);
})();
